import { EMPTY_OBJECT } from '../../../constants/common'

import * as styles from './MultiValuedListItems.module.css'

function MultiValuedListItems({
  Container = 'div',
  Item,
  activeItem,
  className = styles.MultiValuedListItems,
  disabled,
  done,
  isSingle,
  itemProps = EMPTY_OBJECT,
  items,
  size,
  unread,
  variant,
  onClickItem,
  onMouseDownItem,
  ...containerProps
}) {
  return (
    <Container {...containerProps} className={className}>
      {items.map((item, index) => (
        <Item
          {...itemProps}
          {...item}
          activeItem={activeItem}
          disabled={disabled}
          done={done}
          isSingle={isSingle}
          key={item.key || index}
          size={size}
          unread={unread}
          variant={variant}
          onClick={onClickItem}
          onMouseDown={onMouseDownItem}
        />
      ))}
    </Container>
  )
}

export default MultiValuedListItems
